import React from 'react';

import { Deploy, isContractTypeCep18 } from '@block-explorer/entities';

import {
  FlexColumn,
  FlexRow,
  formatTimestampAge,
  TableData,
  TableRow,
} from '@make-software/cspr-ui';
import { BodyText, Tooltip } from '@block-explorer/ui';

import {
  DeployStatus,
  DeployStatusSize,
  isDeployAmountInCspr,
  PrecisionCase,
  TableDataActionMessage,
  TableDataCurrencyAmount,
} from '../../../components';
import { useGetCep18AmountFromMetadata } from '../../../hooks/use-get-cep18-amount-from-metadata';
import { TransactionHashLink } from '../../../components/hash-link/transaction-hash-link.tsx';
import { getAmountFromDeploy } from '../../../utils/amount';

interface HomeDeploysListItemProps {
  data: Deploy;
  loading: boolean;
}

export const HomeDeploysListItem = ({
  data,
  loading,
}: HomeDeploysListItemProps) => {
  const {
    contractPackage,
    deployHash,
    timestamp,
    timeTransactionCurrencyRate,
    args,
  } = data;
  const isCep18 = isContractTypeCep18(contractPackage);

  const { data: cep18AmountData } = useGetCep18AmountFromMetadata(
    isCep18 && contractPackage ? { contractPackageInfo: contractPackage } : null
  );

  const isCSPR = isDeployAmountInCspr(data);
  const amount = getAmountFromDeploy(args);

  return (
    <TableRow>
      <TableData>
        <FlexColumn>
          <FlexRow align={'center'}>
            <DeployStatus deployResult={data} size={DeployStatusSize.Small} />
            <Tooltip title={deployHash}>
              <BodyText size={3} monotype>
                <TransactionHashLink isDetails hash={deployHash} />
              </BodyText>
            </Tooltip>
          </FlexRow>
          <BodyText size={3} variation="darkGray" loading={!data}>
            {formatTimestampAge(timestamp)}
          </BodyText>
        </FlexColumn>
      </TableData>
      <TableData>
        <TableDataActionMessage deployData={data} loading={loading} isHome />
      </TableData>
      <TableData align={'right'}>
        <TableDataCurrencyAmount
          isCSPR={isCSPR}
          amount={amount}
          cep18AmountData={isCep18 ? cep18AmountData : null}
          csprCurrencyRate={timeTransactionCurrencyRate}
          loading={loading}
          precisionCase={PrecisionCase.small}
        />
      </TableData>
    </TableRow>
  );
};

export default HomeDeploysListItem;
